import { getFormatPhoneNumber, getFullNameFromFio, getShortNameFromFio } from 'helpers/string'
import { User } from 'modules/login/types'

import { TFieldErrors, TUserDocumentType, UserDocumentTypeEnum } from '../types'

export const getUserFullName = (user: User | undefined): string => {
  const emptyResult = 'Не указано'

  if (!user) {
    return emptyResult
  }

  return (
    getFullNameFromFio({ lastname: user?.lastname, firstname: user?.firstname, secondname: user?.secondname }) ||
    emptyResult
  )
}

export const getUserShortName = (user: User | undefined): string => {
  const emptyResult = ''

  if (!user) {
    return emptyResult
  }

  return (
    getShortNameFromFio({ lastname: user?.lastname, firstname: user?.firstname, secondname: user?.secondname }) ||
    emptyResult
  )
}

export const isUserProfileCompleted = (user: User | undefined): boolean => {
  if (!user) {
    return false
  }

  return !!user?.firstname
}

export const getUserPhone = (user: User | undefined): string => {
  if (!user) {
    return ''
  }

  return getFormatPhoneNumber(user?.phone)
}

export const getFieldError = (errorDocument: TFieldErrors[], name: string) => {
  if (errorDocument) {
    const error = errorDocument.find((el) => el.path === name)

    if (error) {
      return error.title
    }

    return false
  }

  return false
}

export const setDocumentTypes = (documentTypes: TUserDocumentType[] | undefined) => {
  if (!documentTypes) {
    return []
  }

  return documentTypes.map((el) => {
    const name = `${el.title}`

    return {
      ...el,
      name,
      id: el.code
    }
  })
}

export const getDocumentLabel = (type?: string) => {
  switch (type as UserDocumentTypeEnum) {
    case UserDocumentTypeEnum.DriverLicense:
      return 'Водительское удостоверение'
    case UserDocumentTypeEnum.PassportInternational:
      return 'Заграничный паспорт'
    case UserDocumentTypeEnum.PassportRF:
      return 'Паспорт'
    default:
      return 'Документ, удостоверяющий личность'
  }
}
